import React, { useState } from 'react';
import { connect } from 'react-redux';

import { changeLanguage } from 'redux/actions/exchangeSettings';
import { Modal, Box, ButtonNew, Image, Text } from 'components/Wrapped';
import styles from './LanguageToggler.module.scss';

const langs = [
  {
    code: 'ru',
    label: 'Русский',
    icon: 'assets/img/countries/rus.svg',
  },
  {
    code: 'en',
    label: 'English',
    icon: 'assets/img/countries/eng.svg',
  },
];

const Language = ({ fullLanguage, changeLanguage, languageList, margin, buttonTheme = 'black' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeLang, setActiveLang] = useState('ru');

  // const onChange = (value) => {
  //   changeLanguage(value);
  // };

  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <React.Fragment>
      <ButtonNew theme={buttonTheme} label={<Image src="/assets/img/lang.svg" />} width="40px" height="40px" onClick={toggleModal} />
      <Modal show={isOpen} toggleModal={toggleModal} width="large" pad="medium">
        <Box pad={{ horizontal: '12px', vertical: '18px' }}>
          <Text size="18px" weight={500}>
            Язык
          </Text>
        </Box>
        <Box pad="none" gap="4px">
          {langs.map((lang) => (
            <Box
              key={lang.code}
              pad={{ horizontal: '12px', vertical: '14px' }}
              direction="row"
              gap="10px"
              round="12px"
              className={styles.langItem}
              onClick={() => setActiveLang(lang.code)}
            >
              <Box pad="none" height="20px" width="20px">
                <Image src={lang.icon} />
              </Box>
              <Text weight={600}>{lang.label}</Text>
              {activeLang === lang.code && (
                <Box pad="none" height="20px" margin={{ left: 'auto' }} width="20px">
                  <Image src="assets/img/check.svg" />
                </Box>
              )}
            </Box>
          ))}
        </Box>
      </Modal>
      {/* <Select
        options={languageList}
        defaultValue={fullLanguage}
        margin={margin}
        valueKey="code"
        labelKey="language"
        onChange={onChange}
      /> */}
    </React.Fragment>
  );
};

const mapStateToProps = ({ exchangeSettings: { fullLanguage, languageList } }) => ({
  fullLanguage,
  languageList,
});

export default connect(mapStateToProps, { changeLanguage })(Language);
